import { render, staticRenderFns } from "./SendCollection.vue?vue&type=template&id=5f6cebd0&scoped=true&"
import script from "./SendCollection.vue?vue&type=script&lang=js&"
export * from "./SendCollection.vue?vue&type=script&lang=js&"
import style0 from "./SendCollection.vue?vue&type=style&index=0&id=5f6cebd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6cebd0",
  null
  
)

export default component.exports